// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"44":"3dbc44995db7a3ac","752":"51717820a16d976f","936":"7b6745ca2c341672"}[chunkId] + ".js";
};